import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import SidebarContext from "../../contexts/MyContext";
import '../../css/footer.css';

const Footer = () => {
    const location = useLocation()
    const { premiumStatus, setPremiumStatus } = useContext(SidebarContext)


    const isCenteredPath = location.pathname === '/support' || location.pathname === '/accountsetting' || location.pathname === '/accountsetting/account' || location.pathname === '/accountsetting/settingpassword'
        || location.pathname === '/accountsetting/recordingquality' || location.pathname === '/accountsetting/audioformat' || location.pathname === '/accountsetting/syncwithcloud' || location.pathname === '/accountsetting/support' || location.pathname === '/accountsetting/manage-plan'

    // if ((premiumStatus?.status === 'SUCCESS' || premiumStatus?.status === 'FAILURE' ||  premiumStatus?.response?.data?.status === 'FAILURE' || premiumStatus?.status === 'CANCEL' || premiumStatus?.response?.data?.status === 'CANCEL' || premiumStatus?.status === 'INTIATED_IN_PROGRESS' || premiumStatus?.response?.data?.status === 'INTIATED_IN_PROGRESS') && location.pathname === '/pricing') {
    //     return null;
    // }

    const currentYear = new Date().getFullYear()
    return (
        <>

            <div
                style={{
                    background: location.pathname === '/pricing' ? '#ffffff' : '#F8FAFC',
                    padding: '32px 0',
                    zIndex: '100',
                    borderTop: '1px solid #E2E8F0',
                }}
            >
                <div className="container footer-main">
                    <div
                        // className={`row align-items-center ${isCenteredPath
                        //     ? "justify-content-center text-center"
                        //     : "justify-content-between text-sm-center text-md-start text-lg-start"
                        //     }`}
                        className="row align-items-center justify-content-center text-center"
                    >
                        <div className="col-12 col-md-7 mb-3 mb-md-0" style={{ textAlign: isCenteredPath ? "center" : "" }}>
                            <ul className="list-inline mb-2">
                                <li className="list-inline-item me-3">
                                    <a
                                        href="https://voicememo.co/privacy-policy.html"
                                        style={{
                                            fontFamily: "Metropolis",
                                            fontWeight: "400",
                                            fontSize: "14px",
                                            textDecoration: "none",
                                            color: "#000",
                                        }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Privacy Policy
                                    </a>
                                </li>
                                <li className="list-inline-item me-3">
                                    <a
                                        href="https://voicememo.co/terms-of-use.html"
                                        style={{
                                            fontFamily: "Metropolis",
                                            fontWeight: "400",
                                            fontSize: "14x",
                                            textDecoration: "none",
                                            color: "#000",
                                        }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Terms of Use
                                    </a>
                                </li>
                                <li className="list-inline-item me-3">
                                    <a
                                        href="https://voicememo.co/support.html"
                                        style={{
                                            fontFamily: "Metropolis",
                                            fontWeight: "400",
                                            fontSize: "14px",
                                            textDecoration: "none",
                                            color: "#000",
                                        }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Contact Us
                                    </a>
                                </li>
                            </ul>
                            <p
                                className="mb-0"
                                style={{
                                    color: "#B1B1B1",
                                    fontFamily: "Metropolis",
                                    fontWeight: "400",
                                    fontSize: "12px",
                                }}
                            >
                                &copy; {currentYear} Voice Recorder. All rights reserved.
                            </p>
                        </div>
                        {/* {!isCenteredPath && (
                            <div className="col-12 col-md-5 text-center text-md-end">
                                <ul className="list-inline mb-0">
                                    <li className="list-inline-item ms-3">
                                        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                                            <img src="/img/footer/instagram.png" alt="Instagram" />
                                        </a>
                                    </li>
                                    <li className="list-inline-item ms-3">
                                        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                                            <img src="/img/footer/facebook.png" alt="Facebook" />
                                        </a>
                                    </li>
                                    <li className="list-inline-item ms-3">
                                        <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
                                            <img src="/img/footer/twitter.png" alt="Twitter" />
                                        </a>
                                    </li>
                                    <li className="list-inline-item ms-3">
                                        <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
                                            <img src="/img/footer/youtube.png" alt="YouTube" />
                                        </a>
                                    </li>
                                    <li className="list-inline-item ms-3">
                                        <a href="https://www.threads.net" target="_blank" rel="noopener noreferrer">
                                            <img src="/img/footer/threads.png" alt="Thread" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        )} */}
                    </div>
                </div>
            </div>

        </>
    );
};

export default Footer;
